/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meta_Intelligence_TitleInputs */



/**
* | output |
* | --- |
* | "Discord server insights" |
*
* @param {Meta_Intelligence_TitleInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const meta_intelligence_title = /** @type {((inputs?: Meta_Intelligence_TitleInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meta_Intelligence_TitleInputs, { locale?: "en" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ ("Инсайты сервера Discord")
	return /** @type {LocalizedString} */ ("Discord server insights")
});